import React, {useReducer} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {
  featuresSetupShowShippingSetupPopup,
  featuresSetupUpdateFeature,
  featuresSetupUpdateFeatures,
} from "../featuresActions";
import {getFilteredFeatures} from "../featuresFunctions";
import ShippingSetupContext, {
  initialShippingSetupValues,
  shippingSetupContextAction,
  shippingSetupContextReducer
} from "./FeaturesSetupShippingSetupContext";
import FeaturesSetupShippingSetupPopupList from "./FeaturesSetupShippingSetupPopupList";
import FeaturesSetupShippingSetupPopupLeft from "./FeaturesSetupShippingSetupPopupLeft";

const FeaturesSetupShippingSetupPopup = (props) => {

  const {featuresSetupShowShippingSetupPopup, showShippingSetupPopup, featuresSetupUpdateFeatures, selectedFeaturesList} = props;

  const [shippingSetupContextState, shippingSetupContextDispatch] = useReducer(shippingSetupContextReducer, initialShippingSetupValues);
  const {shippingSetupList, activeShippingCostIndex, shippingCostValue} = shippingSetupContextState;

  if (!showShippingSetupPopup) {
    return null
  }

  const closePopup = () => {
    featuresSetupShowShippingSetupPopup(false);
  };

  const saveClick = () => {
    if (shippingSetupList[activeShippingCostIndex]) {
      const applyToFeatures = shippingSetupList[activeShippingCostIndex].isCustom
        ? selectedFeaturesList
        : shippingSetupList[activeShippingCostIndex].features;
      if (applyToFeatures && applyToFeatures.length) {
        featuresSetupUpdateFeatures(["shippingCost"],  [shippingCostValue], applyToFeatures)
      }
    }
    closePopup()
  }

  return (
    <ShippingSetupContext.Provider value={{shippingSetupContextState, shippingSetupContextDispatch}} >
      <div className={"ui-popup ui-popup--middle"}>
        <button className="ui-popup-header__close ui-popup-header__close--small" onClick={closePopup}/>
        <div className="ui-popup__header ui-popup__header--center-small">
          <span className="generic-popup-title text-uppercase">
            <FormattedMessage id="features.setup.shippingSetupPopup.title"/>
          </span>
        </div>
        <div className="ui-popup-body ui-popup-body--small">
          <div className="fs-shipping-setup">
            <FeaturesSetupShippingSetupPopupLeft/>
            <div className="fs-shipping-setup__cell">
              <FeaturesSetupShippingSetupPopupList contextState={shippingSetupContextState}
                                                   contextDispatch={shippingSetupContextDispatch}
                                                   contextAction={shippingSetupContextAction}/>
            </div>
          </div>
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button5 ui-button5--wide ui-button5--blue" onClick={closePopup}>
            <FormattedMessage id="messageBox.buttons.cancel"/>
          </button>
          <button className="ui-button5 ui-button5--green" onClick={saveClick}>
            <FormattedMessage id="features.setup.shippingSetupPopup.assignButton"/>
          </button>
        </div>
      </div>
    </ShippingSetupContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {showShippingSetupPopup} = store.featuresSetupState;
  const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesList = getFilteredFeatures(store, true, true);

  return {
    showShippingSetupPopup,
    featuresList,
    selectedFeaturesList,
  };
};

const mapDispatchToProps = {
  featuresSetupShowShippingSetupPopup,
  featuresSetupUpdateFeature,
  featuresSetupUpdateFeatures,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupShippingSetupPopup)
)
